const getOS = function () {
  let ua = window.navigator.userAgent.toLowerCase()
  let iPhone = /iphone/i.test(ua)
  let android = /android/i.test(ua)

  return {
    android: android,
    iPhone: iPhone
  }
}

const chainAsync = function (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * 在指定的范围内生成一个随机整数
 * @param {最小} min num
 * @param {最大} max num
 */
const randomIntegerInRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min

/**
 * 在指定的范围内生成一个随机数
 * @param {最小} min num
 * @param {最大} max num
 */
const randomNumberInRange = (min, max) => Math.random() * (max - min) + min

/**
 * 精确的几位小数
 * @param {数字} n num
 * @param {省略剩几位} decimals num
 */
const round = (n, decimals = 0) => Number(`${Math.round(`${n}e${decimals}`)}e-${decimals}`)

const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a + 0), 0)

const shuffle = ([...arr]) => {
  let m = arr.length
  while (m) {
    const i = Math.floor(Math.random() * m--);
    [arr[m], arr[i]] = [arr[i], arr[m]]
  }
  return arr
}

const getQueryVariable = (variable) => {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) { return pair[1] }
  }
  return (false)
}

export default {
  getOS,
  chainAsync,
  randomIntegerInRange,
  randomNumberInRange,
  round,
  countOccurrences,
  shuffle,
  getQueryVariable
}
